import { compose } from 'recompose';
import UserGroupDetails from './Details';
import apiInterceptor from '../../../../api/interceptor';
import { userGroupApi } from '../../../common/base.api';

const composedUserGroupDetails = compose(apiInterceptor({ ...userGroupApi }))(UserGroupDetails);

export default composedUserGroupDetails;
